import Client from './client';

export default class DisputeImports extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/dispute/imports`, options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/dispute/imports`, {
      ...options,
       method: 'POST',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/dispute/imports/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/dispute/imports/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
